import { render } from "./CatProfile.vue?vue&type=template&id=5f7b85ea&scoped=true"
import script from "./CatProfile.vue?vue&type=script&lang=js"
export * from "./CatProfile.vue?vue&type=script&lang=js"

import "./CatProfile.vue?vue&type=style&index=0&id=5f7b85ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7b85ea"]])

export default __exports__